import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useQuery } from "react-query";

import VirtualTableComponent from "../VirtualTableComponent";
import {
  // deleteVideoDetails, // Commented out in favor of privacy toggle
  // updateAssetPrivacy, // Not used for player assets
  downloadPlayerUploadedPdf,
  getPlayerUploadedAssets,
  getCoachUploadedAssets,
} from "Api/Pages/VideoListApi";

import { getVideoColumns } from "./constants";
import { IPlayerVideoData } from "./types";
import { useAppSelector } from "App/hooks";
import { getAcademyId } from "Utils/utils";
// import { isAllowedTo } from "Utils/helper"; // Not used for player assets
import ButtonIcon from "../ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { DOWNLOAD } from "Pages/Reports/constants";
import { download } from "Api/Pages/cloudinaryAssetUpload";
import USE_QUERY_KEYS_CONSTANTS from "Api/useQueryKeyConstants";

import { RECORDS_PER_PAGE } from "App/constants";

interface IProps {
  playerID?: string;
  coachID?: string;
}

const VideoListComponent = (props: IProps) => {
  const { playerID, coachID } = props;
  const navigate = useNavigate();
  const {
    userDetails: { academy_id },
  } = useAppSelector((state) => state.loginReducer);
  const [currentPage, setCurrentPage] = useState(1);
  const isCoachProfile = Boolean(coachID);
  const {
    data: result,
    refetch: fetchAssets,
    isFetching,
  } = useQuery(
    [
      isCoachProfile
        ? USE_QUERY_KEYS_CONSTANTS.coachVideosList
        : USE_QUERY_KEYS_CONSTANTS.playerVideosList,
      currentPage,
    ],
    () =>
      isCoachProfile
        ? getCoachUploadedAssets({
            academy_id: getAcademyId(academy_id),
            coach_id: coachID,
            page: currentPage,
            per_page: RECORDS_PER_PAGE,
          })
        : getPlayerUploadedAssets({
            academy_id: getAcademyId(academy_id),
            player_id: playerID,
            page: currentPage,
            per_page: RECORDS_PER_PAGE,
          }),
    { refetchOnWindowFocus: false }
  );

  const onDownloadClick = async () => {
    try {
      const data = await downloadPlayerUploadedPdf({
        academy_id: getAcademyId(academy_id),
        player_id: playerID,
      });
      download(data, `${playerID}-report.pdf`);
    } catch (error) {
      console.error("failed to download error: ", error);
    }
  };
  const onRowClick = (rowData: IPlayerVideoData) => {
    if (isCoachProfile) {
      return; // tiles not clickable for coach
    }
    navigate(`/players/${playerID}/asset/${rowData.id}`, { state: rowData });
  };

  useEffect(() => {
    fetchAssets();
  }, [fetchAssets, currentPage]);

  return (
    <>
      {!isCoachProfile && (
        <div className="d-flex align-items-center justify-content-between mb-2 ">
          <ButtonIcon
            className="btn-outline-secondary fs-sm ms-auto"
            onClick={onDownloadClick}
            isdisabled={!result || !result?.data || result?.data.length === 0}
          >
            <FontAwesomeIcon icon={faArrowDown} className="me-2" />
            {DOWNLOAD}
          </ButtonIcon>
        </div>
      )}
      {isFetching && (
        <div className="d-flex justify-content-center mt-4">
          <span>Loading...</span>
        </div>
      )}
      <VirtualTableComponent
        isClickAble={!isCoachProfile}
        onRowClick={onRowClick}
        columns={getVideoColumns(!isCoachProfile)}
        tableData={result?.data || []}
        paginationProps={{
          currentPage: currentPage,
          setPageNumber: (page: number) => {
            setCurrentPage(page);
          },
          totalCount: result?.total_count,
          numberOfRowPerPage: RECORDS_PER_PAGE,
        }}
        noDataMessage="No Videos found"
      />
    </>
  );
};

export default VideoListComponent;
